module.exports = "<div class=\"header\">\n    <div>\n      <h2>{{'Intensity' | translate}}</h2>\n    </div>\n  </div>\n  <div class=\"content\">\n    <div *ngIf=\"properties.intensity && properties.intensity !== 'NODATA'\">\n      <span>{{properties.intensity}} veh/h</span>\n    </div>\n    <div *ngIf=\"properties.intensity && properties.intensity === 'NODATA'\">\n    <span>{{'No data' | translate}}</span>\n    </div>\n  </div>\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/cities/informo/traffics-intensity-popup/traffics-intensity-popup.component.html
// module id = ./src/app/cities/informo/traffics-intensity-popup/traffics-intensity-popup.component.html
// module chunks = main